import config, { embeddedRuntime } from '@/config'
import { session } from '@/composables/useSession'

declare global {
  interface Window {
    __z2MessagingWidgetRef: any
    Z2MessagingWidget: any
  }
}

export function loadZ2MessagingWidget() {
  const Z2_MESSAGING_WIDGET_URL = `https://static${config.zendeskDomain === 'zendesk.com' ? '' : '-staging'}.zdassets.com/z2-sunco-widget/z2-messaging-widget.js`

  if (embeddedRuntime() || !session.account) return

  const nonce = '__CSP_NONCE__'

  // Create the script element
  const widgetScript = document.createElement('script')
  widgetScript.setAttribute('nonce', nonce)
  widgetScript.async = true

  // Set the script and jwt sources based on the environment
  widgetScript.setAttribute('src', Z2_MESSAGING_WIDGET_URL)

  // Configure the script's `onload` behavior
  widgetScript.onload = function () {
    if (typeof window.Z2MessagingWidget === 'function') {
      window.__z2MessagingWidgetRef = new window.Z2MessagingWidget({
        inProduct: true,
        resetAuth: true,
        jwtUrl: '/it-jwt/zendesk-sunco',
        position: {
          side: 'right',
          offset: {
            web: {
              horizontal: '20',
              vertical: '20',
            },
            mobile: {
              horizontal: '10',
              vertical: '10',
            },
          },
        },
        openWidgetToNewConversation: false,
      })

      // Wait for widget to be fully ready before using window.zE
      window.Z2MessagingWidget.ready()
        .then(() => {
          console.info('[Z2MessagingWidget] | widgetScript - is ready')
          // Safe to use window.zE() functions here
        })
        .catch((error) => {
          console.error('[Z2MessagingWidget] | Error while loading the script', { error })
        })
    } else {
      console.warn('[Z2MessagingWidget] | Widget is not available on window.')
    }
  }

  // Append the script to the document head
  document.head.appendChild(widgetScript)
}
